import styles from "./index.module.scss";

function AuthLayout({ children }: React.PropsWithChildren) {
  return (
    <div className={styles.container}>
      <div className={styles.content}>{children}</div>
    </div>
  );
}

export default AuthLayout;
